export default {
  PLATFORM_URL: process.env.PLATFORM_URL || 'http://ffonline-local.foresightfactory.co:3000',
  NVISION_SIGN_IN_URL: process.env.NVISION_SIGN_IN_URL,
  PPTX_DOWNLOAD_URL: process.env.PPTX_DOWNLOAD_URL,
  GRAPHQL_FQDN_HTTPS: process.env.GRAPHQL_FQDN_HTTPS,

  GA_ID: process.env.GA_ID,

  VIRTUAL_HOST: process.env.VIRTUAL_HOST,

  NODE_ENV: process.env.NODE_ENV,

  SENTRY_DSN: process.env.SENTRY_DSN,
  SENTRY_ENV: process.env.SENTRY_ENV,

  MIXPANEL_TOKEN: process.env.MIXPANEL_TOKEN || 'd77603bd1fa0199927dd73b343bea230',
  MIXPANEL_API_HOST: process.env.MIXPANEL_API_HOST || 'http://localhost:4040',
};



// WEBPACK FOOTER //
// ./app/environment/env.js